export default function composeDataWithQuestion(originData, data, deerFlowHook) {
    let dataWithQuestion = { ...data };

    if (originData && originData.length > 0) {
        const lastMessage = originData[originData.length - 1];
        if (lastMessage && lastMessage.question) {
            let questionObj;
            if (typeof lastMessage.question === 'string') {
                questionObj = {
                    originalQuestion: lastMessage.question,
                    activityData: '',
                    reportData: ''
                };
            } else if (typeof lastMessage.question === 'object') {
                questionObj = lastMessage.question;
            } else {
                questionObj = {
                    activityData: '',
                    reportData: ''
                };
            }

            if (!dataWithQuestion.question) {
                dataWithQuestion.question = questionObj;
            }

            if (dataWithQuestion.messages && dataWithQuestion.messages.length > 0) {
                const lastMsgIndex = dataWithQuestion.messages.length - 1;
                if (dataWithQuestion.messages[lastMsgIndex].role === 'ai') {
                    dataWithQuestion.messages[lastMsgIndex].question = questionObj;
                }
            }
        }
    }

    // 当更新消息状态时，确保重新应用 planButtonsDisabled 到所有消息
    if (dataWithQuestion.messages && deerFlowHook && deerFlowHook.planButtonsDisabled) {
        const updatedMessages = dataWithQuestion.messages.map((msg, index, array) => {
            // 只对 AI 消息应用，且不是最后一条
            if (msg.role === 'ai' && index !== array.length - 1) {
                return {
                    ...msg,
                    disabled: true
                };
            }
            return msg;
        });
        dataWithQuestion.messages = updatedMessages;
    }

    return dataWithQuestion;
}


